var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.2C2 21.1941 2.7835 22 3.75 22H14.25C15.2165 22 16 21.1941 16 20.2C16 16.2236 12.866 13 9 13C5.13401 13 2 16.2236 2 20.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.6C12.5 9.58823 10.933 11.2 9 11.2C7.067 11.2 5.5 9.58823 5.5 7.6C5.5 5.61177 7.067 4 9 4C10.933 4 12.5 5.61177 12.5 7.6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.2C16.933 9.2 18.5 7.58822 18.5 5.6C18.5 3.61177 16.933 2 15 2C13.7896 2 12.7228 2.63194 12.0943 3.59254C13.261 4.53321 14 5.99048 14 7.6C14 8.0791 13.9345 8.54472 13.8118 8.98723C14.1828 9.12494 14.5829 9.2 15 9.2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4978 20C17.4147 16.2535 15.0042 13.0522 11.6473 11.9289C11.7535 11.8611 11.8571 11.7893 11.9577 11.7137C12.8776 11.2564 13.9097 11 15 11C18.866 11 22 14.2236 22 18.2C22 19.1941 21.2165 20 20.25 20H17.4978Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users-2.f5462e8432fee3f9c0a423bb713e93f2.svg";
export { ForwardRef as ReactComponent };